import React, { useRef } from "react";
import Header from "../../header.js";
import Footer from "../../footer.js";
import StreamDisplay from "../../streamDisplay.jsx";
import { videoList } from "../../VideoResults/videoResultsID3.js";

const resultsArr = videoList.Kobo;

class Kobo extends React.Component{
    render(){
    
      return(
            <div id="wrapper">

				{/* Header */}
				<Header />

				{/* Menu */}

				{/* Main */}
                <StreamDisplay talentName="Kobo Kanaeru" results={resultsArr} />


        {/* Footer */}
            <Footer />

    </div>
    )
}
}

export default Kobo